import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CoreDirectivesModule } from "@directives/_core/_core.directives.module";
import { AutofocusDirective } from "@directives/_forms/autofocus/autofocus.directive";
import { VFlagToggleListItemComponent } from "@directives/_forms/v-flag-toggle-list-item/v-flag-toggle-list-item.component";
import { VFlagToggleComponent } from "@directives/_forms/v-flag-toggle/v-flag-toggle.component";
import { VInputComponent } from "@directives/_forms/v-input/v-input.component";
import { VToggleListItemComponent } from "@directives/_forms/v-toggle-list-item/v-toggle-list-item.component";
import { MiscDirectivesModule } from "@directives/_misc/_misc.directives.module";
import { TranslationDirectivesModule } from "@directives/_translations/_translations.directives.module";
import { PipesModule } from "src/app/_pipes/_pipes.module";
import { CheckboxComponent } from "./checkbox/checkbox.component";
import { ControlErrorsComponent } from "./control-errors/control-errors.component";
import { FileUploadComponent } from "./fileUpload/fileUpload.component";
import { FormValidationService } from "./form-validation.service";
import { FormDetailsComponent } from "./formDetails/formDetails.component";
import { InputMaskDirective } from "./input-mask/v-input-mask.directive";
import { TextareaComponent } from "./textarea/textarea.component";
import { VAutocompleteComponent } from "./v-autocomplete/v-autocomplete.component";
import { VDriverAutocompleteComponent } from "./v-autocomplete/v-driver-autocomplete/v-driver-autocomplete.component";
import { VVehicleAutocompleteComponent } from "./v-autocomplete/v-vehicle-autocomplete/v-vehicle-autocomplete.component";
import { VEnumSelectComponent } from "./v-enum-select/v-enum-select.component";
import { VOrderButtonsComponent } from "./v-order-buttons/v-order-buttons.component";
import { VSelectOptionComponent } from "./v-select/v-select-option/v-select-option.component";
import { VSelectComponent } from "./v-select/v-select.component";
import { VSliderComponent } from "./v-slider/v-slider.component";
import { VTimePickerComponent } from "./v-time-picker/v-time-picker.component";
import { VToggleComponent } from "./v-toggle/v-toggle.component";
import { VRadioButtonComponent } from "./v-radio-button/v-radio-button.component";
import { SmsInputComponent } from "./smsInput/sms-input.component";
import { PhoneInputDirective } from "./smsInput/phone-input.directive";
import { RadioButtonBaseComponent } from "./_radio-buttons/radio-button-base/radio-button-base.component";
import { RadioButtonCardsComponent } from "./_radio-buttons/radio-button-cards/radio-button-cards.component";
import { RadioButtonSmallCardsComponent } from "./_radio-buttons/radio-button-small-cards/radio-button-small-cards.component";
import { VGeofenceAutocompleteComponent } from "./v-autocomplete/v-geofence-autocomplete/v-geofence-autocomplete.component";
import { VSelectInputComponent } from "./v-select/v-select-input/v-select-input.component";
import { VPlacesAutocompleteComponent } from "./v-autocomplete/v-places-autocomplete/v-places-autocomplete.component";

const privateComponents: any[] = [

];

const publicComponents: any[] = [
    FormDetailsComponent,
    FileUploadComponent,
    VInputComponent,

    VAutocompleteComponent,
    VVehicleAutocompleteComponent,
    VPlacesAutocompleteComponent,
    VDriverAutocompleteComponent,
    VGeofenceAutocompleteComponent,
    VToggleComponent,
    VToggleListItemComponent,
    VFlagToggleComponent,
    VFlagToggleListItemComponent,
    VSelectComponent,
    VSelectOptionComponent,
    VSelectInputComponent,
    VEnumSelectComponent,
    VInputComponent,
    VTimePickerComponent,
    CheckboxComponent,
    VOrderButtonsComponent,
    VRadioButtonComponent,

    VSliderComponent,

    ControlErrorsComponent,
    TextareaComponent,
    SmsInputComponent,

    RadioButtonBaseComponent,
    RadioButtonCardsComponent,
    RadioButtonSmallCardsComponent
];

const declarations: any[] = [
    AutofocusDirective,
    InputMaskDirective,
    PhoneInputDirective
]

@NgModule({
    imports: [
        CommonModule,
        PipesModule,
        FormsModule,

        TranslationDirectivesModule,
        CoreDirectivesModule,
        MiscDirectivesModule
    ],
    providers: [FormValidationService],
    entryComponents: [...publicComponents, ...privateComponents],
    declarations: [...publicComponents, ...privateComponents, ...declarations],
    exports: [...publicComponents, ...declarations]
})
export class FormsDirectivesModule {
    constructor() {
    }
}
